module.exports = __webpack_public_path__ + "img/rotten-tomato-0-59.080e9960.png";